module.exports = __webpack_public_path__ + "img/meterUnusual.74e3b570.png";